import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { UntypedFormArray } from '@angular/forms';
import { Observable, Subject } from 'rxjs';
import { tap, takeUntil } from 'rxjs/operators';

// INTERFACES
import { OptionInterface } from '../../../shared/interfaces/common.interface';

// SERVICES
import { TagApiService } from '../../../shared/services/api/tag-api.service';

@Component({
  selector: 'lum-tag-autocomplete-chip',
  templateUrl: './tag-autocomplete-chip.component.html',
  styleUrls: ['./tag-autocomplete-chip.component.scss'],
})
export class TagAutocompleteChipComponent implements OnInit, OnDestroy {
  @Input()
  inlineChips :boolean = false;

  @Input()
  value :number[] = [];

  @Input()
  formArray :UntypedFormArray;

  @Input()
  bindValue :string | null = 'value';

  @Output()
  optionSelectedChangeEvent = new EventEmitter<any>();

  tags$ :Observable<OptionInterface[]>;
  tags :OptionInterface[];
  selectedTags :OptionInterface[] = [];
  filteredTags :OptionInterface[] = [];

  private onDestroy$ = new Subject();

  constructor(
    private tagApiService :TagApiService,
    private cd :ChangeDetectorRef,
  ) {}

  ngOnInit() :void {
    this.tagApiService.getTags({}, true); // Cache true
    this.getFromService();
    this.getItems().subscribe();
  }

  ngOnDestroy() :void {
    this.onDestroy$.next(null);
    this.onDestroy$.complete();
  }

  onInputChange(tag :string) :void {
    if (typeof tag === 'string') {
      // Filter the tags from tag input
      this.filteredTags = this.tags.filter((tagItem :OptionInterface) =>
        tagItem.label.toLowerCase().includes(tag?.toLowerCase()),
      );
    }
  }

  onAdd(tag :OptionInterface) :void {
    this.selectedTags.push(tag);
    this.filteredTags = this.tags;
    this.optionSelectedChangeEvent.emit(this.selectedTags);
  }

  onRemove(option :OptionInterface) :void {
    this.selectedTags = this.selectedTags.filter(
      (tag :OptionInterface) => tag.value !== option.value,
    );
    this.optionSelectedChangeEvent.emit(this.selectedTags);
  }

  private getFromService() :void {
    this.tags$ = this.tagApiService.tags$;
  }

  private getItems() :Observable<OptionInterface[]> {
    return this.tags$.pipe(
      tap((tags :OptionInterface[]) => {
        this.tags = tags;
        this.filteredTags = tags;

        if (this.formArray?.value?.length) {
          this.selectedTags = this.tags.filter((tag :OptionInterface) =>
            this.formArray.value.includes(tag.value),
          );
        } else if (this.value?.length) {
          this.selectedTags = this.tags.filter((tag :OptionInterface) =>
            this.value.includes(tag.value),
          );
        }
        this.cd.detectChanges();
      }),
      takeUntil(this.onDestroy$),
    );
  }
}
